'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _valueSeq2 = require('./internal/_valueSeq');

var _valueSeq3 = _interopRequireDefault(_valueSeq2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get a Seq of the values in `subject`.
 *
 * @example
 * valueSeq(Map({ one: 1, two: 2, three: 3 }))
 * // returns Seq [ 1, 2, 3 ]
 *
 * @param  {Iterable|Object|Array} subject
 * @return {Seq}
 */
exports.default = _valueSeq3.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/valueSeq.js
// module id = 395
// module chunks = 0 1